export default "__VITE_ASSET__DdZIR17c__"